import type { Lang } from "@/i18n";

/**
 * BCP-47 tag per language. The `-u-nu-latn` Unicode extension forces Western
 * (Latin) digits even under the Marathi locale, per product decision: Marathi
 * text, but familiar 0-9 digits for dates and counts.
 */
const LOCALE_TAG: Record<Lang, string> = {
  en: "en-IN",
  mr: "mr-IN-u-nu-latn",
};

/**
 * Every timestamp the API sends is UTC but carries no zone marker
 * ("2026-10-08T05:00:00"), which JavaScript would read as the viewer's local
 * time. Mark it UTC so it converts properly.
 */
export function parseApiDate(date: string | number | Date): Date {
  if (typeof date === "string" && /^\d{4}-\d{2}-\d{2}[T ]\d{2}:\d{2}/.test(date) && !/(Z|[+-]\d{2}:?\d{2})$/i.test(date)) {
    return new Date(date.replace(" ", "T") + "Z");
  }
  return new Date(date);
}

/** The dashboard shows India time whatever zone the viewer's computer is set to. */
export const DISPLAY_TIME_ZONE = "Asia/Kolkata";

export function formatDate(
  date: string | number | Date,
  lang: Lang,
  options: Intl.DateTimeFormatOptions = { day: "2-digit", month: "short", year: "numeric" }
): string {
  return parseApiDate(date).toLocaleDateString(LOCALE_TAG[lang], { timeZone: DISPLAY_TIME_ZONE, ...options });
}

export function formatDateTime(
  date: string | number | Date,
  lang: Lang,
  options?: Intl.DateTimeFormatOptions
): string {
  return parseApiDate(date).toLocaleString(LOCALE_TAG[lang], { timeZone: DISPLAY_TIME_ZONE, ...options });
}

export function formatNumber(n: number, lang: Lang): string {
  return n.toLocaleString(LOCALE_TAG[lang]);
}
